import 'rc-slider/assets/index.css';
import React, { PureComponent } from 'react';
import Slider from 'rc-slider';
import PropTypes from 'prop-types';

export default class SliderTheme extends PureComponent {
    static propTypes = {
        marks: PropTypes.object,
        value: PropTypes.number,
        // min: PropTypes.number.isRequired,
        // max: PropTypes.number.isRequired,
        tipFormatter: PropTypes.func
    };

    // state = {
    //     value: 0
    // }

    // componentDidMount () {
    //     this.setState({ value: this.props.value })
    // }

    render () {
        // console.log(this.props.value)
        const low = '#5B9EAA'
        const medium = '#F2911B'
        const high = '#F24B59'
        // const { value } = this.state
        return (
            <div className='slider'>
                <div className='slider__min'>
                    <p>{this.props.tipFormatter ? this.props.tipFormatter(this.props.min) : this.props.min}</p>
                </div>
                <div className='slider__max'>
                    <p>{this.props.tipFormatter ? this.props.tipFormatter(this.props.max) : this.props.max}</p>
                </div>
                <Slider
                    step={this.props.step}
                    min={this.props.min}
                    max={this.props.max}
                    value={this.props.value}
                    onChange={value => {
                        this.props.onChange(value)
                    }}
                    marks={this.props.marks} tipFormatter={this.props.tipFormatter}
                    handleStyle={
                        this.props.value === 10 ? { backgroundColor: low }
                            : this.props.value === 55 ? { backgroundColor: medium }
                                : this.props.value === 100 ? { backgroundColor: high }
                                    : {}}

                    trackStyle={
                        this.props.value === 10 ? { backgroundColor: low }
                            : this.props.value === 55 ? { backgroundColor: medium }
                                : this.props.value === 100 ? { backgroundColor: high }
                                    : {}
                    } />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/sra/components/Slider.js